import React from 'react';
import { NavLink } from 'react-router-dom';

const links = [
  { to: '/app-dashboard/featured', end: true, label: 'Featured' },
  { to: '/app-dashboard/coming-soon', end: true, label: 'Coming soon' },
];

const AppDashboardNav = () => (
  <nav className="mb-4 md:mb-6 flex flex-wrap gap-2" aria-label="App Dashboard sections">
    {links.map((link) => (
      <NavLink
        key={link.to}
        to={link.to}
        end={link.end}
        className={({ isActive }) =>
          `px-3 py-1.5 text-sm font-medium rounded-xl transition-colors ${
            isActive
              ? 'bg-brand text-white shadow-sm'
              : 'bg-white text-gray-700 border border-[#ECECEC] hover:bg-gray-50'
          }`
        }
      >
        {link.label}
      </NavLink>
    ))}
  </nav>
);

export default AppDashboardNav;
